export const  urlApi = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRD_API_URL : process.env.REACT_APP_DEV_API_URL;
export const  urlApiFleet = process.env.REACT_APP_FLEET_PRD_API_URL;